module.exports = __webpack_public_path__ + "img/Rainbow.9b5527e1.png";